import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'

@Injectable()
export class AccessTokenInterceptor implements HttpInterceptor {

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const accessToken = localStorage.getItem('ACCESS_TOKEN')
    const isRequestToGraphql = request.url.endsWith('/graphql')

    if (isRequestToGraphql && accessToken) {
      request = request.clone({
        setHeaders: {
          'authorization': `Bearer ${accessToken}`,
          'x-access-token': `Bearer ${accessToken}`,
          'x-client-application-name': 'mountdoom',
          'authorizationApp': 'mountdoom'
        }
      })
    }

    return next.handle(request)
  }
}

